import useTranslations from '~/components/translation/use-translations';

const TAG_TO_TEXT_KEY: Record<string, string> = {
	CASINO: 'MOBILE_MAIN_MENU_CASINO',
	LIVE_CASINO: 'MOBILE_LIVE_CASINO_BUTTON'
};

const useTournamentTags = (tags: string[] | undefined) => {
	const { translations } = useTranslations(Object.values(TAG_TO_TEXT_KEY));
	return tags?.map(i => translations[TAG_TO_TEXT_KEY[i]]).join(', ') || '';
};

export default useTournamentTags;
